"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactDesc = require("react-desc");

// @ts-ignore no module typings
var schema = (0, _reactDesc.describe)({
  displayName: 'Tag'
});
schema.propTypes = {
  items: _reactDesc.PropTypes.arrayOf(_reactDesc.PropTypes.shape({
    id: _reactDesc.PropTypes.string,
    icon: _reactDesc.PropTypes.func.description('Which `iconix` icon to render as the icon option button.'),
    text: _reactDesc.PropTypes.string.description('The label text for an option in the list of toggle options.')
  })).description('The array of item data that will be rendered as toggle options.').isRequired,
  onChange: _reactDesc.PropTypes.func.description('Change event handler, called with the ID of the selected option.').isRequired,
  selected: _reactDesc.PropTypes.string.description('ID value of the option to show as `selected` in the list.').isRequired
};
var _default = schema;
exports.default = _default;